$(document).ready(function(){


  
  if($('.review-main-content-cls').length > 0){
    $('.review-main-content-cls').slick({
      centerMode: true,
      centerPadding: '150px',
      slidesToShow: 2,
      arrows:true,
      prevArrow:'<svg class="review-prev-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none"> <path d="M17 5.25C17.4142 5.25 17.75 5.58579 17.75 6C17.75 6.41421 17.4142 6.75 17 6.75V5.25ZM0.469671 6.53033C0.176777 6.23744 0.176777 5.76256 0.469671 5.46967L5.24264 0.696699C5.53554 0.403805 6.01041 0.403805 6.3033 0.696699C6.5962 0.989592 6.5962 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.5962 10.5355 6.5962 11.0104 6.3033 11.3033C6.01041 11.5962 5.53554 11.5962 5.24264 11.3033L0.469671 6.53033ZM17 6.75L1 6.75V5.25L17 5.25V6.75Z" fill="black"/> </svg>',
      nextArrow:'<svg class="review-next-arrow active" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none"> <path d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM17.5303 6.53033C17.8232 6.23744 17.8232 5.76256 17.5303 5.46967L12.7574 0.696699C12.4645 0.403805 11.9896 0.403805 11.6967 0.696699C11.4038 0.989592 11.4038 1.46447 11.6967 1.75736L15.9393 6L11.6967 10.2426C11.4038 10.5355 11.4038 11.0104 11.6967 11.3033C11.9896 11.5962 12.4645 11.5962 12.7574 11.3033L17.5303 6.53033ZM1 6.75L17 6.75V5.25L1 5.25L1 6.75Z" fill="black"/> </svg>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: 2,
            dots:true
          }
        },
        {
          breakpoint: 990,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1,
            dots:true
          }
        }
      ]
    });
  }

  if($('.cookobook-recipes-products-cls .cookobook-recipes-products-main-cls').length > 0){
    $('.cookobook-recipes-products-cls .cookobook-recipes-products-main-cls').slick({
      centerMode: true,
      centerPadding: '130px',
      slidesToShow: 1,
      arrows:true,
      prevArrow:'<svg class="review-prev-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none"> <path d="M17 5.25C17.4142 5.25 17.75 5.58579 17.75 6C17.75 6.41421 17.4142 6.75 17 6.75V5.25ZM0.469671 6.53033C0.176777 6.23744 0.176777 5.76256 0.469671 5.46967L5.24264 0.696699C5.53554 0.403805 6.01041 0.403805 6.3033 0.696699C6.5962 0.989592 6.5962 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.5962 10.5355 6.5962 11.0104 6.3033 11.3033C6.01041 11.5962 5.53554 11.5962 5.24264 11.3033L0.469671 6.53033ZM17 6.75L1 6.75V5.25L17 5.25V6.75Z" fill="black"/> </svg>',
      nextArrow:'<svg class="review-next-arrow active" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none"> <path d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM17.5303 6.53033C17.8232 6.23744 17.8232 5.76256 17.5303 5.46967L12.7574 0.696699C12.4645 0.403805 11.9896 0.403805 11.6967 0.696699C11.4038 0.989592 11.4038 1.46447 11.6967 1.75736L15.9393 6L11.6967 10.2426C11.4038 10.5355 11.4038 11.0104 11.6967 11.3033C11.9896 11.5962 12.4645 11.5962 12.7574 11.3033L17.5303 6.53033ZM1 6.75L17 6.75V5.25L1 5.25L1 6.75Z" fill="black"/> </svg>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
            dots:true
          }
        },
        {
          breakpoint: 990,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '10px',
            slidesToShow: 2,
            dots:true
          }
        },
        {
          breakpoint: 520,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1,
            dots:true
          }
        }
      ]
    });
  }

  if($('.recipes-main-cls').length > 0){
    $('.recipes-left-main-cls').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true,
      adaptiveHeight:true,
      prevArrow:'<svg class="review-prev-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none"> <path d="M17 5.25C17.4142 5.25 17.75 5.58579 17.75 6C17.75 6.41421 17.4142 6.75 17 6.75V5.25ZM0.469671 6.53033C0.176777 6.23744 0.176777 5.76256 0.469671 5.46967L5.24264 0.696699C5.53554 0.403805 6.01041 0.403805 6.3033 0.696699C6.5962 0.989592 6.5962 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.5962 10.5355 6.5962 11.0104 6.3033 11.3033C6.01041 11.5962 5.53554 11.5962 5.24264 11.3033L0.469671 6.53033ZM17 6.75L1 6.75V5.25L17 5.25V6.75Z" fill="black"/> </svg>',
      nextArrow:'<svg class="review-next-arrow active" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none"> <path d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM17.5303 6.53033C17.8232 6.23744 17.8232 5.76256 17.5303 5.46967L12.7574 0.696699C12.4645 0.403805 11.9896 0.403805 11.6967 0.696699C11.4038 0.989592 11.4038 1.46447 11.6967 1.75736L15.9393 6L11.6967 10.2426C11.4038 10.5355 11.4038 11.0104 11.6967 11.3033C11.9896 11.5962 12.4645 11.5962 12.7574 11.3033L17.5303 6.53033ZM1 6.75L17 6.75V5.25L1 5.25L1 6.75Z" fill="black"/> </svg>',
      responsive: [
        {
          breakpoint: 990,
          settings: {
            arrows: true,
            adaptiveHeight:true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:false
          }
        }
      ]
    });

    $('.recipes-center-main-cls').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true,
      prevArrow:$('.cstm-review-prev-arrow'),
      nextArrow:$('.cstm-review-next-arrow'),
      responsive: [
        {
          breakpoint: 990,
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:true
          }
        }
      ]
    });

    $('.recipes-right-main-cls').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true,
      prevArrow:'<svg class="review-prev-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none"> <path d="M17 5.25C17.4142 5.25 17.75 5.58579 17.75 6C17.75 6.41421 17.4142 6.75 17 6.75V5.25ZM0.469671 6.53033C0.176777 6.23744 0.176777 5.76256 0.469671 5.46967L5.24264 0.696699C5.53554 0.403805 6.01041 0.403805 6.3033 0.696699C6.5962 0.989592 6.5962 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.5962 10.5355 6.5962 11.0104 6.3033 11.3033C6.01041 11.5962 5.53554 11.5962 5.24264 11.3033L0.469671 6.53033ZM17 6.75L1 6.75V5.25L17 5.25V6.75Z" fill="black"/> </svg>',
      nextArrow:'<svg class="review-next-arrow active" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none"> <path d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM17.5303 6.53033C17.8232 6.23744 17.8232 5.76256 17.5303 5.46967L12.7574 0.696699C12.4645 0.403805 11.9896 0.403805 11.6967 0.696699C11.4038 0.989592 11.4038 1.46447 11.6967 1.75736L15.9393 6L11.6967 10.2426C11.4038 10.5355 11.4038 11.0104 11.6967 11.3033C11.9896 11.5962 12.4645 11.5962 12.7574 11.3033L17.5303 6.53033ZM1 6.75L17 6.75V5.25L1 5.25L1 6.75Z" fill="black"/> </svg>',
      responsive: [
        {
          breakpoint: 990,
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:false
          }
        }
      ]
    });

  $('.recipes-right-main-cls').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if (nextSlide > currentSlide) {
        console.log('Next slide move detected');
        $('.recipes-center-main-cls .review-next-arrow').trigger('click');
        $('.recipes-left-main-cls .review-next-arrow').trigger('click');
    } else {
        console.log('Previous slide move detected');
        $('.recipes-center-main-cls .review-prev-arrow').trigger('click');
        $('.recipes-left-main-cls .review-prev-arrow').trigger('click');
    }
  });

  $('.recipes-left-main-cls').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if (nextSlide > currentSlide) {
        console.log('Next slide move detected');
        $('.recipes-center-main-cls .review-next-arrow').trigger('click');
        $('.recipes-right-main-cls .review-next-arrow').trigger('click');
    } else {
        console.log('Previous slide move detected');
        $('.recipes-center-main-cls .review-prev-arrow').trigger('click');
        $('.recipes-right-main-cls .review-prev-arrow').trigger('click');
    }
  });

  $('.recipes-center-main-cls').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if (nextSlide > currentSlide) {
        console.log('Next slide move detected');
        $('.recipes-right-main-cls .review-next-arrow').trigger('click');
        $('.recipes-left-main-cls .review-next-arrow').trigger('click');
    } else {
        console.log('Previous slide move detected');
        $('.recipes-right-main-cls .review-prev-arrow').trigger('click');
        $('.recipes-left-main-cls .review-prev-arrow').trigger('click');
    }
  });
    
  }

  $('.cstm-slide-arrows-cls .slick-arrow').click(function(){
    $('.cstm-slide-arrows-cls .slick-arrow').removeClass('active');
    $(this).addClass('active');
  })


  $('.cstm-nav-filters li.list-menu__item').click(function(e){
    $('.cstm-nav-filters li.list-menu__item').removeClass('active-coll');
    $(this).addClass('active-coll');
    var url = $(this).attr('data-attr');
    $.ajax({
      url: url,
      type: 'GET',
      success: function(response) {
          const html = $(response);
          const productGrid = html.find('#product-grid');    
          $('.product-grid-container .collection').html(productGrid);
          },
      error: function(error) {
          console.error("Error fetching collection page HTML:", error);
      }
    });
  })


  $('.mobile-cstm-filter li.mobile-facets__item.list-menu__item').click(function(e){
    $('.mobile-cstm-filter li.mobile-facets__item.list-menu__item label').removeClass('active-coll');
    $(this).find('label').addClass('active-coll');
    var url = $(this).attr('data-attr');
    $.ajax({
      url: url,
      type: 'GET',
      success: function(response) {
          const html = $(response);
          const productGrid = html.find('#product-grid');    
          $('.product-grid-container .collection').html(productGrid);
          },
      error: function(error) {
          console.error("Error fetching collection page HTML:", error);
      }
    });
  })


  $('.review-prev-arrow').click(function(){
    $(this).parents('.slick-slider').find('.review-next-arrow').removeClass('active');
    $(this).addClass('active');
  })

  $('.review-next-arrow').click(function(){
    $(this).parents('.slick-slider').find('.review-prev-arrow').removeClass('active');
    $(this).addClass('active');
  })
  
  
})